/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { apiKeysList } from "../../funcs/apiKeysList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1ApiKeysListRequest$inboundSchema,
};

export const tool$apiKeysList: ToolDefinition<typeof args> = {
  name: "api-keys_list",
  description: `List API keys

Retrieves a list of API keys with optional filtering`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await apiKeysList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
